import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {StickyContainer, Sticky} from 'react-sticky';
import {Redirect} from 'react-router-dom';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import LandingPanel from './LandingPanel';
import NavHeader from '../../components/LightHeader/NavHeader';
import {Container, Arrow, DarkBlock, SpecialOfferWrapper} from './LightHomePage.style';
import {BLOCK_TYPES, URL_QUERY_PARAMS} from '../../constants/constant';
import {Dishes} from './Dishes';
import {PicText} from './PicText';
import {Icons} from './Icons';
import OpeningTimes from './OpeningTimes';
import FullOpeningTimes from './FullOpeningTimes';
import {isRestaurantOpen} from '../../helpers/date.helper';
import arrowIcon from '../../assets/icons/arrow.svg';
import {isIE11} from '../../helpers/ie.helper';
import {getBackgroundImage} from '../../helpers/string.helper';
import {SpecialOffer} from './SpecialOffer';
import FSArating from '../../components/FSArating/FSArating';
import {getSiteUrls} from '../../helpers/url.helper';

class LightHomePage extends PureComponent {
  constructor(props) {
    super(props);
    const {location} = props;
    const params = new URLSearchParams(location.search);
    const tableId = params.get(URL_QUERY_PARAMS.TABLE_ID);
    this.state = {
      showFullTimes: false,
      navUrls: getSiteUrls(tableId || null)
    };
    this.toggleFullTimes = this.toggleFullTimes.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  toggleFullTimes() {
    this.setState({showFullTimes: !this.state.showFullTimes});
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  scrollDown(height) {
    if (isIE11()) {
      window.scrollTo(0, height);
    } else {
      window.scrollTo({
        top: height,
        behavior: 'smooth'
      });
    }
  }

  render() {
    const {restaurant, template, serverOffline} = this.props;
    const {navUrls} = this.state;
    if (restaurant.externalWebsiteUrl) {
      return <Redirect to={navUrls.menuUrl} />;
    }
    const isOpen = isRestaurantOpen(restaurant.openingTimes, restaurant.modes, serverOffline);
    const OrderButtonText = isOpen && restaurant.modes && restaurant.modes.onlineOrdering ? 'home.order' : (restaurant.modes.futureOrders ? 'home.preorder' : 'home.viewMenu');
    const isTemplateLight = restaurant && restaurant.template && restaurant.template.light;
    const firstColor = isTemplateLight && restaurant.template.light.brandFirstColour;
    const secondColor = isTemplateLight && restaurant.template.light.brandSecondColour;
    const backgroundImageUrl = restaurant.backgroundImages && restaurant.backgroundImages.desktop;
    const backgroundImages = getBackgroundImage(backgroundImageUrl);
    const renderHomeBlocks =
      isTemplateLight &&
      restaurant.template.light.homeBlocks &&
      restaurant.template.light.homeBlocks.map((block, i) => {
        switch (block.type) {
          case BLOCK_TYPES.DISHES:
            return (
              <Dishes
                key={block.title + i}
                OrderButtonText={OrderButtonText}
                block={block}
                navUrls={navUrls}
              />
            );
          case BLOCK_TYPES.PIC:
            return (
              <PicText
                key={block.title + i}
                block={block}
                firstColor={firstColor}
                secondColor={secondColor}
              />
            );
          default:
            return (
              <Icons
                key={block.title + i}
                block={block}
                isDeliveryMode={restaurant.modes && restaurant.modes.delivery}
              />
            );
        }
      });
    const renderOpeningTimes =
      isTemplateLight &&
      restaurant.template.light.openingTimes && (
        <OpeningTimes
          restaurant={restaurant}
          firstColor={firstColor}
          secondColor={secondColor}
          backgroundImages={backgroundImages}
          toggleFullTimes={this.toggleFullTimes}
        />
      );
    const renderFullOpeningTimes =
      this.state.showFullTimes &&
      isTemplateLight &&
      restaurant.template.light.openingTimesLink && (
        <FullOpeningTimes restaurant={restaurant} />
      );
    const renderSpecialOffer = restaurant && restaurant.content && restaurant.content.promotions &&
      (restaurant.content.promotions.menuPage || (restaurant.content.promotions.message && restaurant.content.promotions.message.length > 0)) && (
      <DarkBlock>
        <SpecialOfferWrapper>
          <SpecialOffer
            promotions={restaurant.content.promotions}
            black={true}
          />
        </SpecialOfferWrapper>
      </DarkBlock>
    );

    return (
      <Container>
        <LandingPanel
          restaurant={restaurant}
          headerColor={template.headerColour}
          OrderButtonText={OrderButtonText}
          firstColor={firstColor}
          secondColor={secondColor}
          backgroundImages={backgroundImages}
          scrollDown={this.scrollDown}
          navUrls={this.state.navUrls}
        />
        <StickyContainer>
          <Sticky>
            {({style}) => (
              <NavHeader
                name={restaurant.name}
                template={restaurant.template}
                modes={restaurant.modes}
                goHome={this.scrollToTop}
                isOpen={isOpen}
                style={style}
                navUrls={navUrls}
              />
            )}
          </Sticky>
          {renderHomeBlocks}
          {renderOpeningTimes}
          {renderFullOpeningTimes}
          {renderSpecialOffer}
          <FSArating restaurant={restaurant} />
        </StickyContainer>
        <Arrow
          src={arrowIcon}
          onClick={this.scrollToTop}
        />
      </Container>
    );
  }
}

LightHomePage.propTypes = {
  restaurant: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  serverOffline: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language,
    template: state.template,
    serverOffline: state.serverOffline
  };
};

export default connect(mapStateToProps)(ContextProvider(LightHomePage));



// WEBPACK FOOTER //
// ./containers/LightHomePage/LightHomePage.js